export type YtApiKeys = {
  ytMediaDownloaderKey: string;
  ytApiKeys: string[];
};

export interface YouTubeTrack {
  data: Blob;
  title: string;
  image?: string;
}

export class InvalidLinkError extends Error {
  link?: string;
  constructor(message: string, link?: string) {
    super(message);
    this.name = "InvalidLinkError";
    this.link = link;
  }
}

export class VideoDurationExceededError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "VideoDurationExceededError";
  }
}

export class DownloadTrackError extends Error {
  response: any;

  constructor(message: string, response?: any) {
    super(message);
    this.name = "DownloadTrackError";
    this.response = response;
  }
}

export class ProxyParseError extends Error {
  proxyUrl: any;
  ytUrl: any;

  constructor(proxyUrl: string, ytUrl: string, message?: string) {
    super(message);
    this.name = "DownloadTrackError";
    this.proxyUrl = proxyUrl;
    this.ytUrl = ytUrl;
  }
}

export class YoutubeDownloadServiceUnavailableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "YoutubeDownloadServiceUnavailableError";
  }
}
